// interlinked-tdd: exempt
//
// Single source of truth for the curated MCP server catalog. Used by:
//  - /api/mcp-servers   (UI catalog)
//  - /api/mcp-status    (health probe targets)
//  - /api/codemode/proxy (key->URL lookup for V8 isolate calls)
// Service bindings in wrangler.jsonc (`MCP_<UPPER_SNAKE_KEY>`) must stay in
// sync with the `key` values below. `theme` mirrors the three MCP Server
// Portals (Genomics / Pharma / Clinical) and drives the themed chat presets.
// The catalog is split by portal into ./curated/{genomics,pharma,clinical}.ts
// to stay under the file-size cap; add a new server to the matching theme file.
import { GENOMICS_SERVERS } from "./curated/genomics";
import { PHARMA_SERVERS } from "./curated/pharma";
import { CLINICAL_SERVERS } from "./curated/clinical";

export type { ServerTheme, CuratedServer } from "./curated/types";
import type { CuratedServer } from "./curated/types";

export const CURATED_SERVERS: CuratedServer[] = [
  ...GENOMICS_SERVERS,
  ...PHARMA_SERVERS,
  ...CLINICAL_SERVERS,
];

const BY_KEY: Record<string, CuratedServer> = Object.fromEntries(
  CURATED_SERVERS.map((s) => [s.key, s]),
);

export function getCuratedServer(key: string): CuratedServer | undefined {
  return BY_KEY[key];
}
